
import Button from '@/components/ui/button/index.vue';
import Input from '@/components/ui/input/index.vue';
import { computed, onMounted, ref } from 'vue';
import { ENV, FEATURENAME } from '@/enum/enum';
import { apiInitSetting, apiLogin, getNewCSRFToken } from '@/api/api';
import { useRouter } from 'vue-router';
import { checkEnvFromDomain } from '@/utils/utils';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
// import axios from 'axios';
export default {
  components: {
    Button,
    Input
  },
  props: [],
  setup() {
    const { t } = useI18n();
    let _env = checkEnvFromDomain();
    const router = useRouter();
    const store = useStore();
    const brand = computed(() => store.state.brand);

    let currentEnv = ref('');
    let username = ref('');
    let password = ref('');

    const isLoginDisable = computed(() => {
      return password.value === '' || username.value === ''
    }) //isLoginDisable

    onMounted(() => {
      currentEnv.value = _env;
      // temp
    });

    let loginASUS = () => {
      const currentHost = window.location.origin;
      console.log('currentHost', currentHost);
      let method = "post";
      let params = {AppID: "proart0004", ReturnURL: `${currentHost}/verifySSO` };
      let form = document.createElement("form");
      form.setAttribute("method", method);
      let uri = "https://account.asus.com";
      form.setAttribute("action", uri + "/signin.aspx");

      for (let key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          let hiddenField = document.createElement("input");
          hiddenField.setAttribute("type", "hidden");
          hiddenField.setAttribute("name", key);
          hiddenField.setAttribute("value", params[key]);
          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    } //end: login

    const login = async () => {
      console.log('_env', _env)
      console.log('aftaer apiInitSetting');
      loginGTM()

      if (_env === ENV.PROD) {
        loginASUS();
        //todo
        // let params = {
        //   lang: "zh-tw",
        //   site: "tw",
        //   AppID: "proart0004",
        //   ReturnURL: "https://proartcc.asus.com/verifySSO"
        // };

        // let loginURL = 'https://account.asus.com';

        // await axios({
        //   method: 'post',
        //   url: `${loginURL}/signin`,
        //   data: params,
        //   // headers: { 'Content-Type': 'multipart/form-data' }
        // })
        // console.log('after prod login')
      }
      else if (_env === ENV.DEV || _env === ENV.MOCK) {
        if(isLoginDisable.value) return;
        await apiInitSetting();
        router.push({ name: FEATURENAME.DASHBOARD });
      }
      else {
        if(isLoginDisable.value) return;
        await getNewCSRFToken();
        await apiInitSetting();
        const conifg = {
          email: username.value,
          password: password.value
        }
        try {
          const response = await apiLogin(conifg);
          if (response.message === 'success') {
            router.push({ name: FEATURENAME.DASHBOARD });
          }
          else {
            alert('Login Error');
          }// 

        }
        catch (err) {
          console.warn('error in apiLogin');
        }//end: catch

      } //end: else 

    } // login

    const loginGTM =  () => {
      window.dataLayer?.push({
        event: 'myevent',
        userIdLogin : 'name'
      });


    } // login

    

    return {
      currentEnv,
      ENV,
      username,
      password,
      login,
      isLoginDisable,
      loginASUS,
      t,
      loginGTM,
      brand
    }
  } //end; setup
}


